<template>
  <div>
    <el-tabs @tab-remove="handleRemove" closable v-model="activeTab" type="border-card" @tab-click="handleClick"
             class="tab">
      <el-tab-pane
        v-for="item in tabs"
        :key="item[0]"
        :label="item[0]"
        :name="item[0]"
      >
      </el-tab-pane>
      <router-view class="root-view"></router-view>
    </el-tabs>
  </div>
</template>

<script>
  import bus from '@/utils/EventBus'

  export default {
    name: 'customTabs',
    props: [],
    data () {
      return {
        activeTab: '',
        tabs: [],
        tabMap: new Map()
      }
    },
    created () {
      bus.$on('add', tabObj => {
        this.tabMap = tabObj.m
        this.tabs = [...tabObj.m.entries()]
        this.activeTab = tabObj.n
      })
    },
    updated () {},
    methods: {
      handleClick (tab, event) {
        this.$router.push(this.tabMap.get(tab.name))
        bus.$emit('activeMenu')
      },

      handleRemove (name) {
        this.tabMap.delete(name)
        this.tabs = [...this.tabMap.entries()]
        let len = this.tabs.length
        if (len > 0) {
          this.$router.push(this.tabs[len - 1][1])
          this.activeTab = this.tabs[len - 1][0]
        } else {
          this.$router.push('/main')
        }
        bus.$emit('activeMenu')
      }
    }
  }
</script>
<style scoped>
  .el-tabs--border-card > .el-tabs__header {
    background-color: red !important;
  }

  .tab {
    /*background-color: #ecf0f0;*/
     background-color: #FFF;
  }

  .pane {
    height: 100%;
  }

  .root-view {
    height: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tab.vue